<template>
  <aside>
    <app-count-down v-if="getUtilisateurId" :formCountDown="false"/>
    <button type="button" class="current-menu-button cursor-text">
      <font-awesome-icon :icon="currentMenuItem.icon"></font-awesome-icon>
      <span class="span-1">{{ currentMenuItem.titre }}</span>
      <span v-if="checkCurrentTitle(currentMenuItem.titre)" class="span-2">{{ num_rows }}</span>
    </button>
    <hr class="separator">
  </aside>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'
import CountDown from "./CountDown";

export default {
  name: "Banner",
  props: {
    num_rows: {
      type: Number
    }
  },
  data(){
    return{
      currentMenuItem: null
    }
  },
  components: {
    AppCountDown: CountDown,
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
    checkCurrentTitle(titre){
      switch (titre){
        case 'historique sms':
        case 'mes contacts':
          return true;
        default:
          return false
      }
    }
  },
  computed: {
    ...mapGetters([
      'getMenu',
      'getUtilisateurId',
    ])
  },
  watch: {},
  beforeCreate() {},
  created() {
    let routePath = this.$route.path
    this.currentMenuItem = this.getMenu.filter( (item) => item.path === routePath)[0]
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
.separator{
  border: none;
  opacity: 1;
  height: 2px;
  background: var(--color-second-radial-gradient-1);
}
aside{
  text-align: right;
  & > .current-menu-button{
    background: var(--color-third-0-8);
    color: var(--color-first);
    text-transform: uppercase;
    border-radius: 0;
    & > span.span-1{
      display: inline;
      font-size: larger;
      font-weight: normal;
    }
    & > span.span-2{
      background: var(--color-first);
      color: var(--color-second);
      border-radius: 50%;
      padding: .2rem;
    }
  }
  & > hr{
    background: var(--color-second);
    margin: 0 auto 2rem auto;
  }
}

@media (min-width: 576px) {}

@media (min-width: 768px) {}

@media (min-width: 992px) {}
</style>



// WEBPACK FOOTER //
// src/components/shared/Banner.vue